import { useState } from 'react';
import { useAppApi } from '../../app/ApiProvider';
import { useI18n } from '../../i18n/I18nProvider';
import { CtaBar, CtaButton } from '../../ui/Cta';
import { Alert, ErrorState } from '../../ui/feedback';
import { Screen, ScrollArea, TopBar } from '../../ui/Screen';

/** Совпадает с `MAX_FEEDBACK_LEN` бэкенда: длиннее сервер отвергнет. */
const MAX_LEN = 1000;

/** Пожелание пользователя. Бот пересылает его в чат команды (`FEEDBACK_CHAT_ID`). */
export function FeedbackScreen(props: { onBack: () => void }): JSX.Element {
  const { t } = useI18n();
  const api = useAppApi();
  const [text, setText] = useState('');
  const [state, setState] = useState<
    { status: 'idle' | 'sending' | 'sent' } | { status: 'failed'; error: unknown }
  >({ status: 'idle' });

  const send = async (): Promise<void> => {
    setState({ status: 'sending' });
    try {
      await api.client.sendFeedback(text.trim());
      setState({ status: 'sent' });
      setText('');
    } catch (error) {
      setState({ status: 'failed', error });
    }
  };

  return (
    <Screen>
      <TopBar title={t('fbTitle')} onBack={props.onBack} />
      <ScrollArea bottomGap="cta">
        <div className="px-4 pt-5 text-[13px] leading-[1.5] text-ink-2">{t('fbSub')}</div>
        <div className="px-4 pt-3">
          <textarea
            value={text}
            onChange={(event) => setText(event.target.value.slice(0, MAX_LEN))}
            placeholder={t('fbPh')}
            rows={7}
            className="w-full resize-none rounded-[12px] bg-surface-2 px-3.5 py-3 text-[14.5px] text-ink outline-none placeholder:text-ink-3 focus:shadow-[inset_0_0_0_1.5px_var(--accent)]"
          />
          <div className="mt-1 text-right text-[11px] text-ink-3">
            {text.length}/{MAX_LEN}
          </div>
        </div>
        {state.status === 'sent' ? (
          <div className="px-4 pt-2">
            <Alert>{t('fbThanks')}</Alert>
          </div>
        ) : null}
        {state.status === 'failed' ? <ErrorState error={state.error} /> : null}
      </ScrollArea>
      <CtaBar>
        <CtaButton
          onClick={() => void send()}
          disabled={text.trim().length === 0 || state.status === 'sending'}
        >
          {t('fbSend')}
        </CtaButton>
      </CtaBar>
    </Screen>
  );
}
